<template>
  <div id="div-tabela-kpis-ressarcimento-by-municipio">
    <div v-if="isLoading" class="div-loading">
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <template>
      <v-text-field
        v-if="numMunicipios > 10"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mb-5 break-search"
        label="Procurar"
        hide-details
        single-line
      />
      <v-data-table
        class="data-table-kpis"
        dense
        :headers="headers"
        :items="items"
        :search="search"
        :items-per-page="10"
        no-data-text="Nenhum registro disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      >
        <template
          v-for="h in headers"
          v-slot:[`header.${h.value}`]="{ header }"
        >
          <v-tooltip bottom v-if="traducaoIndicadores[h.value] != null">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ h.text }}</span>
            </template>
            <span>{{ traducaoIndicadores[h.value] }}</span>
          </v-tooltip>
          <span v-else>{{ h.text }}</span>
        </template>

        <template v-slot:[`item.qntd_ressarcimento_danos_eletricos`]="{ item }">
          {{
            item.qntd_ressarcimento_danos_eletricos
              | parseNumberToFloatBrIgnoringNaN
          }}
        </template>
        <template v-slot:[`item.percentual_negadas`]="{ item }">
          {{ item.percentual_negadas | parseNumberToFloatBrIgnoringNaN }}%
        </template>
        <template v-slot:[`item.qntd_indeferidas_danos_eletricos`]="{ item }">
          {{
            item.qntd_indeferidas_danos_eletricos
              | parseNumberToFloatBrIgnoringNaN
          }}
        </template>
        <template v-slot:[`item.solicitacoes_deferidas`]="{ item }">
          R$ {{ item.solicitacoes_deferidas | parseNumberToFloatBrIgnoringNaN }}
        </template>
        <template
          v-slot:[`item.valor_pago_ressarcimento_danos_eletricos`]="{ item }"
        >
          R$
          {{
            item.valor_pago_ressarcimento_danos_eletricos
              | parseNumberToFloatBrIgnoringNaN
          }}
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
export default {
  name: "KpisByMunicipioDataTable",
  props: {
    dadosKpisByMunicipio: {
      type: Object,
      required: true,
    },
    traducaoIndicadores: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    headers: [
      {
        text: "IBGE",
        value: "codigo_municipio",
        width: "100px",
      },
      {
        text: "Município",
        value: "nome_municipio",
        width: "150px",
      },
      {
        value: "percentual_negadas",
        text: "% Negadas",
        width: "100px",
      },
      {
        value: "qntd_ressarcimento_danos_eletricos",
        text: "Qtd. Ressarcimentos",
        width: "120px",
      },
      {
        value: "qntd_indeferidas_danos_eletricos",
        text: "Qtd. Indeferidas",
        width: "120px",
      },
      {
        value: "solicitacoes_deferidas",
        text: "Valor Pendente Deferido (R$)",
        width: "150px",
      },
      {
        value: "valor_pago_ressarcimento_danos_eletricos",
        text: "Valor Pago (R$)",
        width: "150px",
      },
    ],
    search: "",
  }),
  computed: {
    numMunicipios() {
      return this.items ? this.items.length : 0;
    },
    items() {
      if (!this.dadosKpisByMunicipio) return [];

      return Object.entries(this.dadosKpisByMunicipio).map(
        ([nomeMunicipio, dados]) => ({
          codigo_municipio: dados.codigo_municipio,
          nome_municipio: nomeMunicipio,
          qntd_ressarcimento_danos_eletricos:
            dados.qntd_ressarcimento_danos_eletricos,
          qntd_indeferidas_danos_eletricos:
            dados.qntd_indeferidas_danos_eletricos,
          percentual_negadas: dados.percentual_negadas,
          solicitacoes_deferidas: dados.solicitacoes_deferidas,
          valor_pago_ressarcimento_danos_eletricos:
            dados.valor_pago_ressarcimento_danos_eletricos,
        }),
      );
    },
  },
  methods: {},
};
</script>

<style>
#div-tabela-kpis-ressarcimento-by-municipio {
  min-height: 420px;
  position: relative;
}
.data-table-kpis table tbody tr td {
  font-size: 12px;
  padding: 0px 8px !important;
}
.data-table-kpis table thead tr th {
  font-size: 12px;
  height: 25px;
  font-weight: 400;
}
</style>
